"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropDownContext = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var DropDownContext = /*#__PURE__*/_react.default.createContext({
  close: function close() {},
  closeOnClick: false,
  tabFocus: true
});

exports.DropDownContext = DropDownContext;